module.exports = __webpack_public_path__ + "media/packs/images/metrics/search-8eee20c7557f8b5d3f0b83abcec84e97.svg";